import React, { useState } from "react";
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Grid,
  Paper,
  Card,
  CardContent,
} from "@mui/material";
import {
  School,
  PersonAdd,
  Verified,
  Description,
  People,
  Work,
  Label,
} from "@mui/icons-material";
import CollegeAutoComplete from "../components/autocomplete/CollegeAutoComplete";
import CityAutoComplete from "../components/autocomplete/CityAutoComplete";
import { fetchCaptchaApi } from "../services/captchaApi";
import { CustomAlert, showToastAlert } from "../admin/components/CustomAlert";
import { collegeRegister } from "../services/college";
import { useNavigate } from "react-router";
import { isValidIndianMobileNumber } from "../common/commonFunctions";
import { Helmet } from "react-helmet-async";
const CollegeRegistration = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    collegeName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    designation: "",
    department: "",
    city: "",
    answer: "",
    captchaHex: "",
  });

  const [captchaImg, setCaptchaImg] = useState("");

  const validateForm = () => {
    let validationErrors = {};

    if (!formData.collegeName)
      validationErrors.collegeName = "College Name is required";
    if (!formData.firstName)
      validationErrors.firstName = "First Name is required";
    if (!formData.lastName) validationErrors.lastName = "Last Name is required";
    if (!formData.email) validationErrors.email = "Email is required";
    if (!formData.phone) validationErrors.phone = "Mobile Number is required";
    if (!formData.designation)
      validationErrors.designation = "Designation is required";
    if (!formData.department)
      validationErrors.department = "Department is required";
    if (!formData.city) validationErrors.city = "City is required";
    if (!formData.answer)
      validationErrors.answer = "CAPTCHA answer is required";
    if (!isValidIndianMobileNumber(formData.phone)) {
      validationErrors.phone = "Mobile Number is not valid indian number";
    }

    if (Object.keys(validationErrors).length > 0) {
      showToastAlert(Object.values(validationErrors).join("\n"), "error");
      return false;
    }

    return true;
  };

  const registerCollege = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const response = await collegeRegister({
        collegeData: formData,
      });
      if (response.status === 200) {
        navigate("/college-account-created");
      } else {
        showToastAlert(response.data.message, "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    window.scrollTo(0, 0);
    fetchCaptcha();
  }, []);

  const fetchCaptcha = async () => {
    try {
      const res = await fetchCaptchaApi();
      if (res) {
        setCaptchaHex(res.hex);
        setCaptchaImg(res.img);
      }
    } catch (error) {
      console.error("Error fetching CAPTCHA", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const setCaptchaHex = (name) => {
    setFormData({ ...formData, captchaHex: name });
  };

  const setCollege = (name) => {
    setFormData({ ...formData, collegeName: name });
  };

  const setCity = (name) => {
    setFormData({ ...formData, city: name });
  };

  const setAnswer = (name) => {
    setFormData({ ...formData, answer: name });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
  };

  return (
    <>
      <Helmet>
          <title >Register your college with HeyInterns</title>
          <meta name="description" content="Maximize your students opportunities by connecting with 1000+ companies" />
          <meta property="og:title" content="Register your college with HeyInterns" />
      </Helmet>
      <div className="signup-background">
        <img
          src="/heyinterns-signup.jpg"
          alt="Background"
          className="img-fluid mob-banner-image"
        />
        <div className="">
          <div className="signup-form-wrapper">
            <div className="heading-box">
              <h2>Registration form for college authorities</h2>
              <p>Hire faster, powered by AI</p>
            </div>

            <Grid item xs={12} md={6}>
              <div>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <label className="login-form-label">College Name</label>
                      <CollegeAutoComplete
                        value={formData.collegeName}
                        setCollege={setCollege}
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <label className="login-form-label">
                        College Location
                      </label>
                      <CityAutoComplete
                        label="City"
                        setCity={setCity}
                        value={formData.city}
                        required
                        size="small"
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="First Name"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Last Name"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                        size="small"
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Official Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                        size="small"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Mobile Number"
                        name="phone"
                        type="tel"
                        value={formData.phone}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                        size="small"
                      />
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl fullWidth margin="normal" size="small">
                        <Select
                          name="designation"
                          value={formData.designation}
                          onChange={handleChange}
                          required
                          size="small"
                          displayEmpty
                          inputProps={{ "aria-label": "Designation" }}
                          renderValue={
                            formData.designation !== ""
                              ? undefined
                              : () => (
                                  <span style={{ color: "#aaa" }}>
                                    Choose designation
                                  </span>
                                )
                          }
                        >
                          <MenuItem value="" disabled>
                            <span style={{ color: "#aaa" }}>
                              Choose designation
                            </span>
                          </MenuItem>
                          <MenuItem value="Training & Placement Officer (Faculty)">
                            Training & Placement Officer (Faculty)
                          </MenuItem>
                          <MenuItem value="Training & Placement Officer (Staff)">
                            Training & Placement Officer (Staff)
                          </MenuItem>
                          <MenuItem value="Head of Department">
                            Head of Department
                          </MenuItem>
                          <MenuItem value="Dean">Dean</MenuItem>
                          <MenuItem value="Director">Director</MenuItem>
                          <MenuItem value="Professor">Professor</MenuItem>
                          <MenuItem value="Registrar">Registrar</MenuItem>
                          <MenuItem value="Student Placement Coordinator">
                            Student Placement Coordinator
                          </MenuItem>
                          <MenuItem value="Student">Student</MenuItem>
                          <MenuItem value="Others">Others</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth margin="normal" size="small">
                        <Select
                          name="department"
                          value={formData.department}
                          onChange={handleChange}
                          required
                          size="small"
                          displayEmpty
                          inputProps={{ "aria-label": "Department" }}
                          renderValue={
                            formData.department !== ""
                              ? undefined
                              : () => (
                                  <span style={{ color: "#aaa" }}>
                                    Choose department
                                  </span>
                                )
                          }
                        >
                          <MenuItem value="" disabled>
                            <span style={{ color: "#aaa" }}>
                              Choose department
                            </span>
                          </MenuItem>
                          <MenuItem value="Engineering">Engineering</MenuItem>
                          <MenuItem value="Management">Management</MenuItem>
                          <MenuItem value="Science">Science</MenuItem>
                          <MenuItem value="Arts">Arts</MenuItem>
                          <MenuItem value="Commerce">Commerce</MenuItem>
                          <MenuItem value="Design/Architecture">
                            Design/Architecture
                          </MenuItem>
                          <MenuItem value="Pharma">Pharma</MenuItem>
                          <MenuItem value="Medical">Medical</MenuItem>
                          <MenuItem value="Law">Law</MenuItem>
                          <MenuItem value="Others">Others</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <img src={captchaImg} alt="CAPTCHA" />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        onChange={(e) => setAnswer(e.target.value)}
                        size="small"
                        required
                        fullWidth
                        label="Enter CAPTCHA"
                        className="mt-2"
                        inputProps={{ maxLength: 15 }}
                      />
                    </Grid>
                  </Grid>

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={registerCollege}
                    size="large"
                  >
                    Register now
                  </Button>
                </form>
              </div>
            </Grid>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="heading-box">
          <h2>Why Choose us</h2>
          <p>Hire early talent with work experience up to 2 years</p>
        </div>
        <div className="row mt-5">
          <div className="col-sm-4 col-md-4 ">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon3.png" alt="" />
              </figure>
              <h5>🌐 Wide Network</h5>
              <p>
                Connect with a wide network of companies and students for better
                placement opportunities.
              </p>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 ">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon2.png" alt="" />
              </figure>
              <h5>✅ Personalised Dashboard</h5>
              <p>
                Get regular updates to monitor students' internship selections.
                Quickly identify top talent with our free resume assessments.We
                help you scan through applicants.
              </p>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 ">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon1.png" alt="" />
              </figure>
              <h5>🎯 Job Fit Scoring</h5>
              <p>
                Our smart algorithm evaluates each applicant's resume against
                your internship requirements, providing a Job Fit Score that
                helps you instantly recognize ideal matches.
              </p>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 ">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon3.png" alt="" />
              </figure>
              <h5>🤝 Help Every Step of the Way</h5>
              <p>
                From posting your internship to selecting the right intern, we
                guide you throughout the process. Our tools are built to make
                hiring easier, faster, and more efficient.
              </p>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 ">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon1.png" alt="" />
              </figure>
              <h5>📈 Analytics & Reports</h5>
              <p>
                Access detailed analytics and reports to track application
                trends and student performance.
              </p>
            </div>
          </div>
          <div className="col-sm-4 col-md-4 ">
            <div className="inner-box">
              <figure className="image">
                <img src="/icons/icon2.png" alt="" />
              </figure>
              <h5>🔒 Secure & Verified</h5>
              <p>
                All data is securely stored and verified to ensure privacy and
                authenticity for your institution.
              </p>
            </div>
          </div>
          <CustomAlert />
          
        </div>
      </div>
    </>
  );
};

export default CollegeRegistration;
